import React from 'react';
import InContentAd from 'ads/InContentAd';
import classNames from 'classnames';
import { BucketLayout, PageType } from 'enums';
import SearchBucketsHeader from 'page/search/SearchBucketsHeader';
import BucketHeader from './BucketHeader';
import CollectionBucketHeader from './CollectionBucketHeader';
import Tile from './Tile';


const LayoutThresholds = {
    DEFAULT: 4,
    DEFAULT_SUPERSIZE: 8,
    DEFAULT_UNLIMITED: undefined,
    TAPESTRY_LEFT: 5,
    TAPESTRY_RIGHT: 5,
    COLLECTION: undefined
};

function isTileFeatured(props, index) {
    if (!props.isCollectionPage && props.contents) {
        if ((props.layoutType === BucketLayout.TAPESTRY_LEFT || props.layoutType === BucketLayout.TAPESTRY_RIGHT)
            && index === 0) {
            return true;
        }
    }
    return false;
}

const Bucket = (props) => {
    const {
        bucketId,
        groupId,
        heroContentId,
        iconHref,
        layoutType,
        link,
        metadata,
        name,
        pageType,
        tags,
        liveLabel
    } = props;

    const contents = props.contents.filter((content) => heroContentId !== content.id);

    // determine the threshold of items to display in a bucket
    let layoutThreshold = LayoutThresholds[layoutType];
    const supersizeLayoutThreshold = LayoutThresholds[`${layoutType}_SUPERSIZE`];
    if (supersizeLayoutThreshold && contents.length >= supersizeLayoutThreshold) {
        layoutThreshold = supersizeLayoutThreshold;
    }

    // add classes based on the layoutType
    const collectionClassName = classNames('collection', {
        'collection--watch': [BucketLayout.TAPESTRY_LEFT, BucketLayout.TAPESTRY_RIGHT].indexOf(layoutType) === -1,
        'collection--featured-left': (layoutType === BucketLayout.TAPESTRY_LEFT),
        'collection--featured-right': (layoutType === BucketLayout.TAPESTRY_RIGHT)
    });

    const isPagePreview = tags && (tags.indexOf('page_preview') !== -1);
    const bucketSize = metadata.displayCount || props.contents.length;
    const displaySize = !isPagePreview;
    // TODO: fix this when the correct url is coming back from the page api
    const bucketLink = (isPagePreview) ? `/${name.toLowerCase()}` : link;

    let header = <BucketHeader name={name} size={bucketSize} link={bucketLink} displaySize={displaySize} />;
    let placement = `home-${name}-grid`;
    switch (pageType) {
        case PageType.COLLECTION:
            header = <CollectionBucketHeader name={name} iconHref={iconHref} tags={tags} />;
            placement = `collections-${name}-grid`;
            break;
        case PageType.FEATURES:
            placement = `features-${name}-grid`;
            break;
        case PageType.SEARCH:
            placement = `search-${props.name}-grid`;
            header = <SearchBucketsHeader name={props.name} logoUrl={props.logoUrl} tags={props.tags} />;
            break;
        default:
            break;
    }

    /* eslint-disable */
    const collectionRowChildren = contents.slice(0, layoutThreshold).map((content, index) => (
        <Tile
            bucketId={bucketId}
            content={content}
            groupId={groupId}
            featured={isTileFeatured(props, index)}
            key={`tile-${bucketId}-${index}:${content.id}:`}
            layoutType={layoutType}
            placement={placement}
            liveLabel={liveLabel}
        />
    ));
    /* eslint-enable*/

    // TODO: is there a better way to do this?
    if (pageType === PageType.COLLECTION) {
        collectionRowChildren.splice(6, 0,
            <InContentAd key="collection_row_in_content_ad" include={['s']} adClassName="ad-slot-incontent2" refreshWhenVisible />
        );
    }

    const collectionRowClassName = classNames('collection_row', {
        'collection_row--collections': (pageType === PageType.COLLECTION),
        'collection_row--showAll': (pageType === PageType.COLLECTION)
    });

    return (
        <div className={collectionClassName}>
            {header}
            <div className={collectionRowClassName}>
                {collectionRowChildren}
            </div>
        </div>
    );
};

Bucket.propTypes = {
    bucketId: React.PropTypes.number,
    contents: React.PropTypes.array,
    groupId: React.PropTypes.number,
    heroContentId: React.PropTypes.number,
    iconHref: React.PropTypes.string,
    layoutType: React.PropTypes.string,
    link: React.PropTypes.string,
    logoUrl: React.PropTypes.string,
    metadata: React.PropTypes.object,
    name: React.PropTypes.string,
    pageType: React.PropTypes.string,
    tags: React.PropTypes.array,
    liveLabel: React.PropTypes.string
};

Bucket.defaultProps = {
    contents: [],
    layoutType: BucketLayout.DEFAULT,
    metadata: {},
    name: ''
};

export default Bucket;



// WEBPACK FOOTER //
// ./app/page/buckets/Bucket.js